import React from 'react';
import {Button, withStyles} from 'material-ui';
import Dropzone from 'react-dropzone';
import grey from 'material-ui/colors/grey';
import AddIcon from 'material-ui-icons/PictureAsPdf';
import SectionDocuments from '../../containers/builder/form/section_documents';

const styles = theme => ({
    chip: {
        margin: '0 10px 20px 0',
    },
    svgIcon: {
        color: grey[800],
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    buttonIconSmall: {
        width: 25,
        height: 25,
        marginLeft: 5
    },
    documentIcon: {
        width: 25, 
        height: 25, 
        color: '#940000'
    },
});

class DropzoneDocumentField extends React.Component {

    constructor() {
        super();
        this.state = {
            dropzoneActive: false
        }
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
    }

    onDragEnter() {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    render() {

        const {dropzoneActive} = this.state;

        const {documents, onDocumentDelete, onDocumentClick, onDocumentsDrop, classes, multiple} = this.props;

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.5em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#9dffe2'
        };

        let dropzoneRef;

        return (
            <div>
                <Dropzone
                    disableClick
                    multiple={multiple}
                    style={{position: "relative"}}
                    accept="application/pdf"
                    onDrop={(documents) => {
                        onDocumentsDrop(documents);
                        this.setState({
                            dropzoneActive: false
                        });
                    }}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    ref={(node) => {dropzoneRef = node; }}
                >
                    {dropzoneActive && <div style={overlayStyle}>Drop document(s)...</div>}

                    <div>
                        <h3>{multiple ? 'Upload Documents' : 'Upload Document'}</h3>
                        <h4>Drop {multiple ? 'files' : 'file'} here or click button to select {multiple ? 'documents' : 'document'}</h4>
                        <div className={classes.row}>
                            <SectionDocuments
                                documents={documents}
                                onDocumentDelete={onDocumentDelete}
                                onDocumentClick={onDocumentClick}
                                classes={classes}
                            />
                        </div>
                    </div>
                </Dropzone>
                <Button size="small" color="default" variant="raised" onClick={() => {dropzoneRef.open() }} className={classes.buttonAdd}>
                    {multiple ? 'Open Files' : 'Open File'}
                    <AddIcon className={classes.buttonIconSmall}/>
                </Button>
            </div>
        )
    }
}

export default withStyles(styles)(DropzoneDocumentField);


// WEBPACK FOOTER //
// ./src/components/fields/field_dropzone_document.js